import { BreakpointsOptions } from '@mui/system/createTheme/createBreakpoints'

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1580,
  },
}
